import { CheckCircle2, XCircle } from 'lucide-react';

export const MetricCard: React.FC<{
  label: string;
  value: string | number;
  subtext?: string;
  metricBg: string;
  icon?: React.ReactNode;
  valueColor?: string;
}> = ({ label, value, subtext, metricBg, icon, valueColor }) => (
  <div className="rounded-lg p-4" style={{ backgroundColor: metricBg }}>
    <div className="flex items-center gap-2 mb-1">
      {icon}
      <span className="text-xs text-secondary uppercase">{label}</span>
    </div>
    <div
      className="text-2xl font-bold text-primary"
      style={valueColor ? { color: valueColor } : undefined}
    >
      {value}
    </div>
    {subtext && <div className="text-xs text-secondary">{subtext}</div>}
  </div>
);

export const SectionHeader: React.FC<{
  icon: React.ReactNode;
  title: string;
  iconColor?: string;
}> = ({ icon, title, iconColor }) => (
  <h4 className="text-sm font-semibold text-primary mb-3 flex items-center gap-2">
    <span style={iconColor ? { color: iconColor } : undefined}>{icon}</span>
    {title}
  </h4>
);

export const DistributionBar: React.FC<{
  label: string;
  value: number;
  total: number;
  trackColor: string;
  barColor: string;
}> = ({ label, value, total, trackColor, barColor }) => {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div className="flex items-center gap-3">
      <div className="w-24 text-xs text-secondary">{label}</div>
      <div
        className="flex-1 h-6 rounded-full overflow-hidden"
        style={{ backgroundColor: trackColor }}
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, backgroundColor: barColor }}
        />
      </div>
      <div className="w-16 text-right">
        <span className="text-sm font-medium text-primary">{value}</span>
        <span className="text-xs text-secondary ml-1">({pct}%)</span>
      </div>
    </div>
  );
};

export const BooleanIndicator: React.FC<{
  value: boolean;
  trueLabel?: string;
  falseLabel?: string;
  showIcon?: boolean;
}> = ({ value, trueLabel = 'Yes', falseLabel = 'No', showIcon = true }) => (
  <span
    className={`flex items-center gap-1 ${value ? 'text-emerald-600 dark:text-emerald-400' : 'text-slate-500'}`}
  >
    {showIcon && (value ? <CheckCircle2 className="w-4 h-4" /> : <XCircle className="w-4 h-4" />)}
    {value ? trueLabel : falseLabel}
  </span>
);

export const RiskImplicationsPanel: React.FC<{ message: string; theme: string }> = ({
  message,
  theme,
}) => (
  <div
    className="rounded-lg p-4 text-sm"
    style={{
      backgroundColor: theme === 'dark' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(254, 226, 226, 0.5)',
      border: `1px solid ${theme === 'dark' ? 'rgba(239, 68, 68, 0.3)' : 'rgba(239, 68, 68, 0.4)'}`,
    }}
  >
    <p className="text-red-800 dark:text-red-200/90">{message}</p>
  </div>
);
